import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from 'src/app/auth/_service/auth.service';

@Directive({ selector: '[soloUsa]' })
export class SoloUsaDirective {
	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private auth: AuthService,
	) {
		if (this.auth.getUser().company.codice === 'USS00') {
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			this.viewContainer.clear();
		}
	}
}
